module.exports = __webpack_public_path__ + "static/northpine-logo-f68187191111754fbd486f97318a7435.png";